import { baseFontSize } from "@src/styles";
/** Convert pixel value to REM value */
export const pxToRem = (px: number) => px / baseFontSize + "rem";
